import Grid from '@mui/material/Grid';
import { BundleItemDropable } from './bundle-item-dropable';

import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { Button } from '@mui/material';

import { useEffect, useState } from 'react';
import { FormInput } from '../../../../../components/hook-form/form-input.component';
import { FormCurrencyInput } from '../../../../../components/hook-form/form-currency-input.component';
import { Service } from '../../../../../models/masters/service';
import { useDeleteData } from '../../../../../hooks/useDeleteData';
import { serviceBundleApiKeyStore } from '../../../../../api/service-bundle-api-key-store';
import { DeleteDialog } from '../../../../../components/delete.component';
import { LoadingIndicator } from '../../../../../components/loading-indicator.component';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { useAuthorize } from '../../../../../hooks/use-authorize';
import { UserPermissionName } from '../../../../../models/user-permission-name';

interface ServiceBundleSplitUp {
  splitEvenly: boolean;
  splitName: string;
  splitAmt: string;
  serviceBundleSplitItems: Service[];
  projectBundleSplitUpID: number;
  serviceBundleID: number;
  accuralAmount: number;
}

interface BundleListFromProps {
  onDrop: (item: Service) => void;
  onRemoveService: (item: Service) => void;
  handleRemoveSplitFromBundle: (item: ServiceBundleSplitUp) => void;
  handleIsVisibleDeleteButton?: (value: boolean) => void;
}

export const BundleListFrom = ({
  onDrop,
  onRemoveService,
  handleRemoveSplitFromBundle,
  handleIsVisibleDeleteButton,
}: BundleListFromProps) => {
  const { control, getValues, setValue } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'serviceBundleSplitUps',
    keyName: 'bid',
  });

  useWatch({
    name: ['serviceBundleSplitUps', 'serviceBundleSplitItems', 'splitName'] || [],
  });
  const [splitUpItem, setSplitUpItem] = useState<any>();
  const [splitUpItemIndex, setfirstIndex] = useState(0);
  const [isDeleteOpen, setIsDelete] = useState(false);
  const { isLoading, isError, error, mutateAsync } = useDeleteData(
    serviceBundleApiKeyStore?.deleteServicSplitUp(splitUpItem?.projectBundleSplitUpID)
  );

  const handleRemoveBundleItem = async (item: any, index: number) => {
    // setSplitUpID(item?.projectBundleSplitUpID);
    setSplitUpItem(item);
    // handleRemoveSplitFromBundle(item);
    setfirstIndex(index);
    setIsDelete(true);
  };

  const handleDeleteSplit = async () => {
    if (splitUpItem?.projectBundleSplitUpID) {
      await mutateAsync();
    }
    handleRemoveSplitFromBundle(splitUpItem);
    remove(splitUpItemIndex);
    setIsDelete(false);
  };

  useEffect(() => {
    if (getValues('serviceBundleSplitUps')?.length > 0) {
      const totalSplitAmt = getValues('serviceBundleSplitUps')?.reduce((total: any, item: any) => {
        const splitAmtNumber = !item.splitAmt ? 0 : parseFloat(item.splitAmt); // Convert 'splitAmt' to a number
        return total + splitAmtNumber; // Add to the running total
      }, 0);

      const formattedTotalSplitAmt = totalSplitAmt?.toFixed(2);
      setValue('bundlePrice', formattedTotalSplitAmt);
    } else {
      setValue('bundlePrice', '');
    }
  }, [getValues('serviceBundleSplitUps')]);

  useEffect(() => {
    if (
      getValues('serviceBundleSplitUps') &&
      getValues('serviceBundleSplitUps')[0]?.serviceBundleSplitItems?.length > 0
    ) {
      handleIsVisibleDeleteButton?.(false);
    } else {
      handleIsVisibleDeleteButton?.(true);
    }
  }, [getValues('serviceBundleSplitUps') && getValues('serviceBundleSplitUps')[0]?.serviceBundleSplitItems]);

  const handleAddSplit = () => {
    // Add a new split with default values
    const newSplit = {
      splitEvenly: true, // Default to true
      splitName: '', // Default split name
      splitAmt: '', // Default amount
      serviceBundleSplitItems: [], // Initialize empty items array
    };

    // Append the new split
    append(newSplit);
  };

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <Grid container spacing={2}>
      <Grid item lg={12} sm={12} xl={12} xs={12} style={{ display: 'flex', gap: '10px' }}>
        <FormInput name="bundleName" label="Bundle Name" />
        <FormCurrencyInput disabled={true} name="bundlePrice" label="Amount" />
      </Grid>
      <Grid item style={{ width: '100%' }}>
        {getValues('serviceBundleSplitUps')?.map((f: any, index: any) => (
          <BundleItemDropable
            key={f.bid}
            propName={`serviceBundleSplitUps.${index}`}
            onDrop={onDrop}
            onRemoveSplit={() => handleRemoveBundleItem(f, index)}
            onRemoveService={onRemoveService}
          />
        ))}

        <Grid>
          <Button
            className="btn btn-primary"
            // onClick={() => append({})}
            onClick={handleAddSplit}
          >
            ADD SPLIT
          </Button>
        </Grid>
      </Grid>
      {isDeleteOpen && (
        <div className="delete-btn-container">
          <Dialog className="modalpopup" title={'CONFIRM DELETE'} onClose={() => setIsDelete(false)}>
            <div>
              <div style={{ padding: '25px 50px' }}>
                <div>Are you sure you want to delete</div>
                <LoadingIndicator isLoading={isLoading} />
              </div>
            </div>
            <DialogActionsBar>
              <div className="d-flex justify-content-between">
                <button className="btn btn-sm btn-default  btn-lightGrey" onClick={() => setIsDelete(false)} autoFocus>
                  Cancel
                </button>
                <button
                  className="btn btn-sm btn-danger  btn-delete"
                  type="button"
                  style={{
                    backgroundColor: isReadOnlyPermission ? '#D7DBDD' : '#FF8A8A',
                    color: isReadOnlyPermission ? 'black' : '#fff',
                    marginLeft: 170
                  }}
                  onClick={handleDeleteSplit}
                  disabled={false || isReadOnlyPermission}
                >
                  Delete
                </button>
              </div>
            </DialogActionsBar>
          </Dialog>
        </div>
      )}
    </Grid>
  );
};
